export class ContactosClienteEmpresaEntity{
    constructor(
        public  Codigo ?:number,
        public  Ciudad ?:number,
        public  Unidad ?:number,
        public  CodigoCliente?:number,
        public  Identificacion ?:string,
        public  Nombres ?:string,
        public  Apellidos ?:string,
        public  Telefono ?:string,
        public  Celular ?:string,
        public  Extension ?:string,
        public  Cargo ?:string,
        public  Email ?:string,
        public  FechaNacimiento ?:Date,
        public  Profesion ?:string,
        public  Hobby ?:string,
        public  NombreConyugue ?:string,
        public  ApellidoConyugue ?:string,
        public  CIConyugue ?:string,
        public  FechaNacConyugue ?:Date,
        public  EmpresaConyugue ?:string,
        public CodigoUsuario?: number
    ){
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/entities/contactos_cliente_empresa_entity.ts